export default "__VITE_ASSET__DR4mLXZ5__"